module.exports = {
      id: "icon-audio-fb-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-audio-fb",
      toString: function () {
        return this.url;
      }
    }